<template>
  <div class="container-fluid">
    <!-- ENCABEZADO -->
    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">
            Detalle de imputación<span v-if="allocation"> #{{ allocation.id }}</span>
          </h1>
          <p v-if="allocation" class="view-header__subtitle">
            <span v-if="clientName">{{ clientName }}</span>
            <span v-if="allocation.created_at"> · {{ formatoDate2Fecha(allocation.created_at) }}</span>
          </p>
        </div>
        <div class="view-header__actions">
          <DownloadDoc
            :pdfurl="pdfurl"
            :open="false"
            :filename="(allocation.provider_name || '') + (allocation.created_at || '') + '.pdf'"
          >
            <button type="button" class="btn view-header__btn">
              <i class="bi bi-download"></i>
              Descargar
            </button>
          </DownloadDoc>
          <DownloadDoc
            :pdfurl="pdfurl"
            :open="true"
            :filename="(allocation.provider_name || '') + (allocation.created_at || '') + '.pdf'"
          >
            <button type="button" class="btn view-header__btn view-header__btn--primary">
              <i class="bi bi-printer"></i>
              Imprimir
            </button>
          </DownloadDoc>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- FACTURAS -->
      <div class="col-md-6">
        <div class="filters-panel__section-title">
          <i class="bi bi-receipt"></i>
          Facturas imputadas
        </div>
        <div class="data-table">
          <div class="table-responsive">
            <table class="table mb-0">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Tipo</th>
                  <th>Número</th>
                  <th class="text-right">Importe</th>
                  <th class="text-right">En Recibo</th>
                  <th class="text-center">Detalle</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="isBusy">
                  <td colspan="6" class="data-table__empty">Cargando…</td>
                </tr>
                <tr v-else-if="!invoices.length">
                  <td colspan="6" class="data-table__empty">Sin facturas imputadas</td>
                </tr>
                <tr v-for="(item, idx) in invoices" v-else :key="'inv-' + idx">
                  <td>{{ formatoFechaHora(item.created_at) }}</td>
                  <td>{{ item.type }}</td>
                  <td>{{ item.number }}</td>
                  <td class="text-right">{{ item.amount }}</td>
                  <td class="text-right">{{ item.pivot && item.pivot.partial }}</td>
                  <td class="text-center">
                    <a
                      :href="`/ventas/index/detalle/${item.sale && item.sale.id}`"
                      class="table-action-btn"
                      title="Ver detalle"
                    >
                      <i class="bi bi-eye"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- RECIBOS -->
      <div class="col-md-6">
        <div class="filters-panel__section-title">
          <i class="bi bi-cash-stack"></i>
          Recibos / Retenciones
        </div>
        <div class="data-table">
          <div class="table-responsive">
            <table class="table mb-0">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Tipo</th>
                  <th>Número</th>
                  <th class="text-right">Importe</th>
                  <th class="text-right">Imputado</th>
                  <th class="text-center">Detalle</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="isBusy">
                  <td colspan="6" class="data-table__empty">Cargando…</td>
                </tr>
                <tr v-else-if="!payments.length">
                  <td colspan="6" class="data-table__empty">Sin recibos imputados</td>
                </tr>
                <tr v-for="(item, idx) in payments" v-else :key="'pay-' + idx">
                  <td>{{ item.created_at }}</td>
                  <td>{{ item.type }}</td>
                  <td>{{ item.number }}</td>
                  <td class="text-right">{{ item.amount }}</td>
                  <td class="text-right">{{ item.pivot && item.pivot.partial }}</td>
                  <td class="text-center">
                    <a
                      :href="`/ventas/cobranzas/detalle-recibo/${item.id}`"
                      class="table-action-btn"
                      title="Ver detalle"
                    >
                      <i class="bi bi-eye"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DownloadDoc from "../global/DownloadDoc";
import formatDateMixin from "../../mixins/formatDateMixin";

export default {
  components: {
    DownloadDoc
  },
  props: ['allocationId'],
  mixins: [formatDateMixin],
  
  data() {
    return {
      pdfurl: process.env.VUE_APP_BASE_URL+'/api/collections/locPDF/' + this.allocationId,
      showModal: false,
      showModalRet: false,
      allocation:'',
      allocationDetails:[],
      invoices:[],
      payments:[],
      invoicesFields: [
          {
            key: 'created_at',
            label: 'Fecha',
            sortable: true,
            formatter: (value) => {
              return this.formatoFechaHora(value);
            }
          },
          {
            key: 'type',
            label: 'Tipo',
            sortable: true
          },
          {
            key: 'number',
            label: 'Numero',
            sortable: false
          },
          {
            key: 'amount',
            label: 'Importe',
            sortable: true,
            // Variant applies to the whole column, including the header and footer
            variant: 'danger'
          },
          {
            key: 'pivot.partial',
            label: 'En Recibo',
            sortable: true,
            // Variant applies to the whole column, including the header and footer
            variant: 'danger'
          }
          ,
          {
            key: 'sale.id',
            label: 'Ver Detalle',
            sortable: true,
            // Variant applies to the whole column, including the header and footer
            variant: 'danger'
          }
      ],
      paymentsFields: [
          {
            key: 'created_at',
            label: 'Fecha',
            sortable: true
          },
          {
            key: 'type',
            label: 'Tipo',
            sortable: true
          },
          {
            key: 'number',
            label: 'Numero',
            sortable: false
          },
          {
            key: 'amount',
            label: 'Importe',
            sortable: true,
            variant: 'danger'
          },
          {
            key: 'pivot.partial',
            label: 'Imputado',
            sortable: true,
            variant: 'danger'
          }
          ,
          {
            key: 'id',
            label: 'Ver Detalle',
            sortable: true,
            variant: 'danger'
          }
      ],
    }
  },
  computed:{
    pos() {
      return this.allocation.pos
    },
    number() { return this.allocation.number },
    clientName() { return this.allocation.client != undefined ? this.allocation.client.name :''},
    created_at() { return this.allocation.created_at },
    isBusy() { return this.allocation == '' }
  },
  methods: {
    getDetailTotal(type) { 
      return this.receiptDetails.filter(d => d.type == type)
        .reduce((accumulator, object) => { return accumulator + object.amount; }, 0);
    },
    getAllocationDetail() {
      var vm = this;
      this.$http.get('/api/collections/getAllocationDetail/' + this.allocationId)
            .then(response => {
              if(response.data.success) {
                vm.allocation = response.data.data.allocation;
                vm.invoices = response.data.data.invoices;
                vm.invoices.forEach(element => {
                    element.type = element.sale.type + '-' + element.sale.letter;
                    element.number = element.sale.pos + '-' + element.sale.number;
                });

                vm.payments = response.data.data.payments
                vm.payments.forEach(element => {
                    element.type = element.receipt_id != null? 'RC': 'RT';
                    element.number = element.receipt_id != null? element.receipt.number: element.withholding.number;
                });
               
              }
            })
            .catch(error => {
              alert(error);
            })
    },
  },
  mounted() {
    this.getAllocationDetail();
  }
}
</script>
<style>

.btn-orange {
    background: #f5c05d;
    background: -ms-linear-gradient(top, #f5c05d 0%, #F2AB27 100%);
    background: linear, to bottom, #f5c05d 0%, #F2AB27 100%;
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='$from', endColorstr='#ffffff',GradientType=0 );
    color: #fff;
    text-shadow: 0px 0px 2px #e4931b;
    border: 1px solid #F2AB27;
    border-bottom: 1px solid #e4931b;
}
</style>

<style lang="css">
    .fix-footer {
      padding-bottom: 100px;
    }
    .receipt-footer {
      position: fixed;
      bottom:0;
      left:0;
      z-index:100;
      background:rgb(242, 244, 247,0.5);
      border-top: 1px solid #4477BD;
      text-align: right;
      padding:20px;
      width: 100%;
    }
    .totals {
      margin-bottom: 0;
    }
    
    .totals li {
      border-bottom:1px solid var(--border);
      padding:10px 0;
      font-size: 1.75rem;
    }
    
    .totals li:first-child {
      padding-top:0;
    }
    
    .totals li:last-child {
      border-bottom:0;
      padding-bottom:0;
    }
    
    .totals li .form-group .input-group .input-group-addon {
      padding:0 12px;
      background: var(--surface);
      border-radius: 0px;
      border-left:0;
      border-top:0;
    }

    .totals li .form-group .input-group input {
      border-radius:0px;
      border-right: 0;
      border-top:0;
      background: var(--surface);
      height: 20px;
    }
    
    .affix {
      margin-right:15px;
    }
    
    
    </style>
